import React, { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  modButtonClasses?: string;
  variant?: "primary" | "secondary";
}

const Button: React.FC<ButtonProps> = ({
  children,
  modButtonClasses,
  variant = "primary",
  ...props
}) => {
  const baseStyles = "px-[1.6rem] py-[1.2rem] rounded-[0.5rem] w-full";
  const variantStyles =
    variant === "primary"
      ? "bg-primary text-black hover:bg-yellow-400"
      : "bg-secondary text-white hover:bg-blue-800";

  return (
    <button
      className={`${baseStyles} ${variantStyles} ${modButtonClasses}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
